import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export function timestampFromDateString(date: string): string {
  return dayjs.utc(date).local().format('MM/DD/YY hh:mm A');
}
